// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/poll_response.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message fingertip.common.type.v1.PollResponseItem
 */
export const PollResponseItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PollResponseItem",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
    { no: 6, name: "poll_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "poll_option_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

